export default "__VITE_ASSET__$aZpzK9X__"